<template>
  <b-card :title="$t('labels.clients')">

    <b-overlay :show="loadingData" variant="transparent" no-wrap />

    <Transfer ref="transferClient"></Transfer>

    <edit-client @refreshCientList="getClients()" ref="modalEditClientC"></edit-client>

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">{{$t('labels.search')}}</label>
          <b-form-input
            v-model="searchTerm"
            :placeholder="$t('labels.search')"
            type="text"
            class="d-inline-block"
          />
          <b-button v-if="$can('create','Client')"
                    class="text-nowrap ml-2"
                    variant="primary"
                    @click="$refs.addUpdateClient.modalShow = true"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="text-nowrap">{{ $t('labels.add') }}</span>
          </b-button>
          <add-update-client ref="addUpdateClient"/>
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <div class="table-responsive pb-3">
      <vue-good-table
        :columns="defineColumnsByAbilities()"
        :rows="rows"
        :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
        :pagination-options="{
        enabled: true,
        perPage:pageLength
        }"
        class="table">

        <template slot="table-row" slot-scope="props">

          <!-- Column: Action -->
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>

                <b-dropdown-item v-if="$can('edit','Client')"
                                 v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                 @click="editClient(props.row)"
                                 variant="outline-primary">
                  <feather-icon
                          icon="Edit2Icon"
                          class="mr-50"
                  />
                  <span>{{ $t("labels.edit") }}</span>
                </b-dropdown-item>

                <!--TODO (REMOVE IN WALLET V2)
                <b-dropdown-item v-if="$can('read','ClientWallet')"
                                 :to="{ name: 'wallets-client-detail', params: { id: props.row.wallet._id } }">
                  <feather-icon
                          icon="CreditCardIcon"
                          class="mr-50"
                  />
                  <span>{{ $t("labels.seeWallet") }}</span>
                </b-dropdown-item>
                !-->

                <b-dropdown-item :to="{ name: 'clients-detail', params: { id: props.row._id } }">
                  <feather-icon
                          icon="LayersIcon"
                          class="mr-50"
                  />
                  <span>{{ $t("labels.detailView") }}</span>
                </b-dropdown-item>

                <b-dropdown-item v-if="$can('delete','Client')"
                                 @click="deleteClient(props.row._id)">
                  <feather-icon
                          icon="TrashIcon"
                          class="mr-50"
                  />
                  <span>{{ $t("labels.delete") }}</span>
                </b-dropdown-item>

              </b-dropdown>
            </span>
          </span>

          <!-- Column: Status -->
          <span v-if="props.column.field === 'status'">
            <span :style="{ color : props.row.status  ? '#28a745' : '#dc3545' }">
              {{ getStatus(props.row.status) }}
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
          {{ props.column.field === 'status' ? '' : props.formattedRow[props.column.field] }}
          </span>

            <!-- TODO REMOVE (WALLET 2.0)
          <span v-if="props.column.field === 'transaction'">

           <div class="d-flex justify-content-center">

            <b-button :disabled="!$can('recharge','Client')"
                      variant="outline-success" class="btn-icon rounded-circle mr-1"
                      v-b-tooltip.hover.top="$t('labels.credit')"
                      @click="transferClient(props.row, 'creditClient')" size="sm">
              <feather-icon icon="PlusIcon" />
            </b-button>

            <b-button :disabled="!$can('recharge','Client')"
                      variant="outline-danger" class="btn-icon rounded-circle"
                      v-b-tooltip.hover.top="$t('labels.debit')"
                      @click="transferClient(props.row, 'debitClient')"
                      size="sm">
              <feather-icon icon="MinusIcon" />
            </b-button>

           </div>

          </span>
            -->

        </template>

        <div slot="emptystate" class="m-2 d-flex justify-content-center">
          No clients to display...
        </div>

        <!-- pagination -->
        <template
          slot="pagination-bottom"
          slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Showing 1 to
              </span>
              <b-form-select
                v-model="pageLength"
                :options="['20', '40', '60', '100']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>

  </b-card>
</template>

<script>
  import {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BOverlay,
    BPagination,
    VBModal, VBTooltip,
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import moment from 'moment'
  import { mapActions } from 'vuex'
  import Ripple from 'vue-ripple-directive'
  import vSelect from 'vue-select'
  import addUpdateClient from './addUpdateClient'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import EditClient from './EditClient'
  import Transfer from '../shared/Transfer'
  import ability from '../../../libs/acl/ability'

  export default {
  components: {
    Transfer,
    EditClient,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    VBModal,
    BForm,
    BButton,
    vSelect,
    BFormCheckbox,
    BCard,
    addUpdateClient,
    BOverlay,
    ToastificationContent
  },

  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },

  data() {
    return {
      loadingData: false,
      formData: {
        name: null,
        lastName: null,
        name: null,
        email: null,
        status: null,
        role: [],
      },
      pageLength: 20,
      dir: false,
      columns: [
        {
          label: 'name',
          field: 'name',
        },
        {
          label: 'tax',
          field: 'tax',
        },
        {
          label: 'description',
          field: 'description',
        },
        {
          label: 'status',
          field: 'status',
        },
        {
          label: "date",
          field: "createdAt",
          formatFn: this.formatCreatedAt,
        },
        // {
        //   label : 'transaction',
        //   field : 'transaction'
        // },
        {
          label: 'action',
          field: 'action',
        }
      ],
      searchTerm: '',
    }
  },

  computed: {
    rows() {
      return this.$store.state.client.clients;
    },
  },

  created() {
    this.getClients()
  },

  methods: {
    ...mapActions("client", ["clients", "destroy", "update","getClientsByEmail"]),

    formatCreatedAt: function(value) {
      return moment(String(value)).format('DD-MM-YYYY HH:MM')
    },

    async deleteClient(id) {
      this.$swal({
        title: this.$t('labels.areYouSure'),
        text: this.$t('labels.notRevert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('labels.yesDelete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      .then(async result => {
        if (result.value) {
          let response = await this.destroy(id)
          if(response){
            this.getClients()
            this.$swal({
              icon: 'success',
              title: this.$t('labels.deleted'),
              text: response.message,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        }
      })
    },

    async getClients() {
      try {
        this.loadingData = true;
        await this.$store.dispatch("client/clients");
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('labels.errorFetchingClientList'),
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error.response ? error.response.data.message : '',
          },
        });
      } finally {
        this.loadingData = false;
      }
    },

    getStatus(status){
      return status ? 'Active' : 'Unactive'
    },

    editClient(value){
      this.formData = value
      delete this.formData.password
      this.$refs.modalEditClientC.showModal(this.formData)
    },

    transferClient(destinationClient,transactionType){
      let user = JSON.parse(localStorage.getItem('userData'))

      const fromWallet = user.client.wallet
      const toWallet = destinationClient.wallet._id

      const entityFrom = {entity: user._id , type : 'USER'}
      const entityTo = {entity: destinationClient._id , type : 'CLIENT' , name : destinationClient.name}

      //auto recharge

      this.$refs.transferClient.showTransactionModal(
              fromWallet,toWallet,entityFrom,entityTo,transactionType)

    },

    isUserClient(clientId){
      let isUserClientFlag = false
      const userData = JSON.parse(localStorage.getItem('userData'))
      if (userData.client._id == clientId)
        isUserClientFlag = true
      return isUserClientFlag
    },

    defineColumnsByAbilities(){
      const baseColumns = [
        { label: this.$t("tableHeader.name"), field: 'name',action : 'read' , resource : 'Client'},
        { label: this.$t("tableHeader.tax"), field: 'tax',action : 'read' , resource : 'Client' },
        { label: this.$t("tableHeader.description"), field: 'description',action : 'read' , resource : 'Client' },
        { label: this.$t("tableHeader.status"), field: 'status',action : 'read' , resource : 'Client' },
        { label: this.$t("tableHeader.date"), field: "createdAt", formatFn: this.formatCreatedAt,action : 'read' , resource : 'Client' },
        // { label : this.$t("tableHeader.transaction"), field : 'transaction',action : 'recharge' , resource : 'Client' },
        { label: this.$t("tableHeader.actions"), field: 'action',action : 'read' , resource : 'Client' }
      ]
      return baseColumns.filter(column => ability.can(column.action ,column.resource ))
    }

  },
}
</script>

<style lang="scss" >
  @import '@core/scss/vue/libs/vue-good-table.scss';
</style>